<!--Dashboard tabs-->
<div class="dashboard-tab">
  <ul class="nav nav-pills" id="pills-tab" role="tablist">
    <li class="nav-item" role="presentation">
      <a class="nav-link" routerLink="../production-overview-admin" routerLinkActive="active">
        Dashboard
      </a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" routerLink="../production-overview-admin-table" routerLinkActive="active">
        Report
      </a>
    </li>
  </ul>
</div>

<section>
  <div class="production-overview mt-3" style="background: #fff">
    <div class="dashboard-filter d-flex flex-wrap flex-lg-nowrap gap-2 mb-3" style="white-space: nowrap">
      <!-- Store filter -->
      <div class="filter-wrapper">
        <div class="dropdown stores">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">{{ storeName }}</small>
            <button class="btn text-nowrap" type="button" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>
          <div class="dropdown-menu p-2 mt-1">
            <ul>
              <li (click)="selectAllStores()"><a class="dropdown-item">All stores</a></li>
              <li *ngFor="let str of stores" (click)="setStore(str)">
                <a class="dropdown-item">{{ str.storeName }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Active status filter -->
      <div class="filter-wrapper">
        <div class="dropdown stores">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">{{ activeStatusLabel }}</small>
            <button class="btn text-nowrap" type="button" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>
          <div class="dropdown-menu p-2 mt-1">
            <ul>
              <li (click)="setActiveStatus(true, 'Active')"><a class="dropdown-item">Active</a></li>
              <li (click)="setActiveStatus(false, 'Inactive')"><a class="dropdown-item">Inactive</a></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Date range -->
      <div class="filter-wrapper date-range" style="cursor: pointer">
        <div class="dropdown">
          <div class="d-flex ps-0" data-bs-toggle="dropdown" style="width: 18rem">
            <button class="btn text-nowrap" type="button" style="border-radius: 8px 0px 0px 8px; border-right: 1px solid #d4d4d4; background: #f5f5f5;">
              <img src="assets/pos/products/ic_leftArrow.svg" />
            </button>
            <input type="text" name="daterangeInput" daterangepicker #dateRange [options]="options"
              (selected)="selectedDate($event, daterange)" style="width: 19rem" />
            <button class="btn text-nowrap" type="button" style="border-radius: 0px 8px 8px 0px; border-left: 1px solid #d4d4d4; background: #f5f5f5;">
              <img src="assets/pos/products/ic_rightArrow.svg" />
            </button>
          </div>
        </div>
      </div>

      <!-- Week color -->
      <div class="filter-wrapper" *ngIf="showWeekColor">
        <div class="dropdown">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">{{ weekColor }}</small>
            <button class="btn text-nowrap" type="button" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>
          <div class="dropdown-menu p-2 mt-1">
            <ul>
              <li (click)="selectAllColors()"><a class="dropdown-item">All Week Colors</a></li>
              <li *ngFor="let wk of weekColorsList" (click)="setWeekColor(wk)">
                <a class="dropdown-item" [style.backgroundColor]="wk.color">{{ wk.displayName }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="create-btn run-report-btn c-pt" [class.is-loading]="isLoading" (click)="runReport()">
        <span class="run-spinner" *ngIf="isLoading"></span>
        <img *ngIf="!isLoading" src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        {{ isLoading ? "Running…" : "Run Report" }}
      </div>
    </div>

    <!-- Empty state -->
    <div class="report-empty-state" *ngIf="!reportHasRun">
      <img src="assets/dashboard/noData.svg" alt="" />
      <h5>Ready when you are</h5>
      <p>Adjust the filters above, then click <strong>Run Report</strong> to generate the table.</p>
      <div class="create-btn run-report-btn c-pt" (click)="runReport()">
        <img src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        Run Report
      </div>
    </div>

    <div *ngIf="reportHasRun" style="position: relative">
      <!-- Loader -->
      <div class="overlay" *ngIf="isLoading">
        <div class="loader"></div>
      </div>

      <div class="report-empty-state report-empty-state--inline" *ngIf="isBackendUnsupported">
        <img src="assets/dashboard/noData.svg" alt="" />
        <h5>Not available yet</h5>
        <p>This report needs additional backend work to support a department-level sell-through summary. Check back later.</p>
      </div>

      <div class="table-container" *ngIf="!isBackendUnsupported && departments.length > 0; else noData">
        <table class="table">
          <thead class="main-head sticky-top">
            <tr>
              <th>Department</th>
              <th class="text-end">Produced Qty</th>
              <th class="text-end">Produced Amount</th>
              <th class="text-end">Sold Qty</th>
              <th class="text-end">Revenue</th>
              <th class="text-end">Sell-Through %</th>
              <th class="text-center">Active</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dept of departments">
              <td>{{ dept.departmentName }}</td>
              <td class="text-end">{{ dept.producedQty | number }}</td>
              <td class="text-end">{{ dept.producedAmount | currency }}</td>
              <td class="text-end">{{ dept.soldQty | number }}</td>
              <td class="text-end">{{ dept.revenue | currency }}</td>
              <td class="text-end">{{ dept.sellThroughPercentage | number: '1.1-1' }}%</td>
              <td class="text-center">
                <span *ngIf="dept.isActive" style="color: #1cbb2c; font-weight: 600;">&#10003;</span>
                <span *ngIf="!dept.isActive" style="color: #eb1e1e; font-weight: 600;">&#10007;</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #noData>
        <div class="report-empty-state report-empty-state--inline" *ngIf="!isBackendUnsupported">
          <img src="assets/dashboard/noData.svg" alt="" />
          <h5>No data found</h5>
          <p>No production activity matches the selected filters. Adjust them and run again.</p>
        </div>
      </ng-template>
    </div>
  </div>
</section>
